import React from 'react';

import theme, { StylableComponent } from '@adsk/alloy-react-theme';

import { defaultLabelGetter } from '../../helpers/defaultGetters';
import { useTranslation } from '../../i18n';
import { GenericItem, ItemToString } from '../../types';

type SelectedProps<TItem extends GenericItem> =
  StylableComponent<HTMLDivElement> & {
    selectedItems?: TItem[] | null;
    itemToString?: ItemToString<TItem>;
  };

const Selected = <TItem extends GenericItem>({
  selectedItems,
  itemToString = defaultLabelGetter,
  children,
  style,
  ...props
}: SelectedProps<TItem>) => {
  const { t } = useTranslation();

  let text;
  if (selectedItems && selectedItems.length === 1) {
    text = itemToString(selectedItems[0]);
  }

  if (selectedItems && selectedItems.length > 1) {
    text = t('SELECTED', {
      count: selectedItems.length,
    });
  }

  return (
    <div
      css={[
        theme.typography.labelMedium,
        {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          color: 'inherit',
          pointerEvents: 'none',
          userSelect: 'none',
          flex: 1,
        },
        style,
      ]}
      {...props}
    >
      {text}
      {children}
    </div>
  );
};

export default Selected;
